import React from 'react';
import './AmbassadorClub.css';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

const Ambassadorclub = () => {
  const leftSlide = {
    hidden: { x: '-100%', opacity: 0 },
    visible: { x: 0, opacity: 1, transition: { duration: 0.8, ease: 'easeOut' } }
  };

  const commandments = [
    { title: "Thou Shalt Always Stay Lit", desc: "Keep vibes immaculate and fun eternal. Stay 100 always." },
    { title: "Thou Shalt Recruit Thy Squad", desc: "Spread the Smaaash word and bring your homies." },
    { title: "Thou Shalt Drip with Pride", desc: "Rock your Smaaash fit with main character energy." },
    { title: "Thou Shalt Never Ghost a Challenge", desc: "If a strike calls, answer with 'Game On.'" },
    { title: "Thou Shalt Live for the 'Gram", desc: "Make your feed fire and stories unforgettable." },
    { title: "Thou Shalt Master Smaaashery", desc: "Bowling, VR, go-karts; own them like a pro." },
    { title: "Thou Shalt Hype Thy Homies", desc: "Cheer, support, and celebrate together." },
    { title: "Thou Shalt Respect the Sigma Code", desc: "Kindness and respect make a legend." },
    { title: "Thou Shalt Drop the Dopest Ideas", desc: "Be the trendsetter and spark moments." },
    { title: "Thou Shalt Always Smaaash It", desc: "No game unplayed, no vibe unmatched." }
  ];

  return (
    <div className="ambassador-club-container">
      {/* ✅ SEO Meta Tags */}
      <Helmet>
        <title>Smaaash Ambassador Club | Be the Face of Fun on Campus</title>
        <meta
          name="description"
          content="Join the Smaaash Ambassador Club and unlock gaming credits, sponsorships, and more! Ideal for fun-loving, energetic college students."
        />
        <meta name="keywords" content="Smaaash Ambassador Club, college ambassadors, gaming credits, student events, campus promotions" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://esmaaash.in/AmbassadorClub" />

        {/* Open Graph */}
        <meta property="og:title" content="Smaaash Ambassador Club | Be the Face of Fun on Campus" />
        <meta property="og:description" content="Join the Smaaash Ambassador Club and unlock gaming credits, sponsorships, and more!" />
        <meta property="og:image" content="https://esmaaash.in/esmaaash_web/uploads/Smaaash_Ambasador_Logo.mp4" />
        <meta property="og:url" content="https://esmaaash.in/AmbassadorClub" />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Smaaash Ambassador Club | Be the Face of Fun on Campus" />
        <meta name="twitter:description" content="Join the Smaaash Ambassador Club and unlock gaming credits, sponsorships, and more!" />
        <meta name="twitter:image" content="https://esmaaash.in/esmaaash_web/uploads/Smaaash_Ambasador_Logo.mp4" />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Smaaash Ambassador Club",
            "url": "https://esmaaash.in/AmbassadorClub",
            "logo": "https://esmaaash.in/esmaaash_web/uploads/Smaaash_Ambasador_Logo.mp4",
            "description": "Join the Smaaash Ambassador Club and unlock gaming credits, sponsorships, and more! Ideal for fun-loving, energetic college students.",
            "sameAs": [
              "https://www.facebook.com/esmaaash",
              "https://www.instagram.com/esmaaash",
              "https://twitter.com/esmaaash"
            ]
          }
          `}
        </script>
      </Helmet>

      <span className="call-to-action1" onClick={() => window.open('https://esmaaash.in/esmaaash_web/esmaaash/login.php')}>
        <strong>Login Here</strong>
      </span>

      <motion.div
        className="ambassador-section"
        variants={leftSlide}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <div className="ambassador-video-container">
          <video autoPlay loop muted playsInline className="ambassador-video">
            <source src="https://esmaaash.in/esmaaash_web/uploads/Smaaash_Ambasador_Logo.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <span className="call-to-action" onClick={() => window.open('/AmbassadorClubRegister', '_blank')}>
          <strong>Register Now</strong>
        </span>

        <h2 style={{ color: "rgb(255, 0, 200)" }}>Smaaash Ambassador Club is Here!</h2>
        <p>
          Love gaming, parties, and unforgettable moments? <span style={{ color: "red" }}>The Smaaash Ambassador Club</span> is your
          chance to shine on campus! Join fun-loving students while mastering skills in marketing, networking, and event management.
        </p>

        <div className="atext">
          <h2>Perks &amp; Benefits</h2>
          <ul>
            <li><span style={{ color: "red" }}>₹5,000 Gaming Credits</span> <span style={{ color: "white" }}> — Unlimited Smaaash fun—bowling, cricket, VR, and more!</span> </li>
            <li><span style={{ color: "red" }}>20 VIP Passes</span> <span style={{ color: "white" }}> — Exclusive access to all Smaaash events.</span> </li>
            <li><span style={{ color: "red" }}>College Sponsorship</span>  <span style={{ color: "white" }}> — Level up your campus events with Smaaash branding.</span> </li>
            <li><span style={{ color: "red" }}>Referral Perks</span>  <span style={{ color: "white" }}> — Friends get 20% off, you become the MVP.</span> </li>
          </ul>
        </div>

        <div className="commandments-section">
          <h2 style={{ color: "rgb(255, 0, 200)" }}>10 Commandments of the Ambassador Club</h2>
          <motion.ol
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={{
              visible: { transition: { staggerChildren: 0.15 } }
            }}
            className="commandments-list"
          >
            {commandments.map((cmd, index) => (
              <motion.li
                key={index}
                style={{ marginBottom: '20px' }}
                variants={{
                  hidden: { opacity: 0, y: 20 },
                  visible: { opacity: 1, y: 0 }
                }}
              >
                <div style={{ fontWeight: 'bold',  color: '#ff9800' }}>
                  {cmd.title}
                </div>
                <div style={{ fontFamily: 'Georgia, serif',  color: '#b6b3b3'}}>
                  {cmd.desc}
                </div>
              </motion.li>
            ))}
          </motion.ol>
        </div>

        <h2 style={{ color: "rgb(255, 0, 200)" }}>Who Are We Looking For?</h2>
        <p>Energetic, social, trendsetting college students who bring the vibe.</p>

        <span className="call-to-action" onClick={() => window.open('/AmbassadorClubRegister', '_blank')}>
          Are you ready to Smaaash it?<br />
          <strong>Register Now</strong>
        </span>
        <br />

        <h2 style={{ color: "rgb(255, 0, 200)" }}>How to Join</h2>
        <p>
          Sign up, answer a few questions, and get ready to <span style={{ color: "red" }}>Smaaash it!</span>
          The stage is set, perks are waiting—are you in?
        </p>
      </motion.div>
    </div>
  );
};

export default Ambassadorclub;
